<template>
  <div id="send-to-participant-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">SEND TO {{ participantSingularName.toUpperCase() }}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">Select a method to deliver the form.</div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="participant.phone_number && currentOrganization.twilioStatus" class="btn green" @click.prevent="send('sms')">Send via SMS</button>
          <button v-if="participant.hasOwnProperty('profile') && participant.profile.hasOwnProperty('email') && participant.profile.email !== ''" class="btn green" @click.prevent="send('email')">Send via Email</button>
          <button class="btn default" @click.prevent="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from "@/components/Spinner";
  import VueUploadComponent from 'vue-upload-component';
  import {mapGetters} from "vuex";
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    name: 'SendToParticipantModal',
    mixins: [
      participantDisplayName
    ],
    components: {
      'VueSpinner': Spinner,
      'file-upload': VueUploadComponent,
    },
    computed: {
      ...mapGetters({
        participant: 'getParticipant',
        currentOrganization: 'getOrganization',
      }),
    },
    mounted() {
      $('#send-to-participant-modal').modal('show');
      $('#send-to-participant-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    methods: {
      send(method) {
        this.$emit('send', method)
        $('#send-to-participant-modal').modal('hide');
      },
      cancel() {
        this.$emit('cancel', true);
        $('#send-to-participant-modal').modal('hide');
      }
    },
  }
</script>



// WEBPACK FOOTER //
// SendToParticipantModal.vue?ff79a3ba